import React from 'react'
import { inject, observer } from "mobx-react"

@inject("store")
@observer
export default class Notification extends React.Component {
  render() {
    const { store } = this.props

    if(store.notification) {
      return (
        <div className="text-center alert alert-success fade show">{ store.notification }</div>
      )
    }
    else {
      return null
    }
  }
}
